var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Rank"},[(!_vm.$store.state.mediaPhone)?_c('r_header'):_vm._e(),(_vm.user)?_c('div',[(_vm.procedure == 0)?_c('my_rank',{attrs:{"info":_vm.myRank}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }